document.addEventListener("DOMContentLoaded", function () {

  document.querySelectorAll('.faq-section').forEach(section => {

    const items = section.querySelectorAll('.faq-item');

    section.addEventListener('click', function (e) {

      const btn = e.target.closest('.faq-question');
      if (!btn) return;

      const item = btn.closest('.faq-item');
      const answer = item.querySelector('.faq-answer');

      items.forEach(other => {
        if (other !== item && other.classList.contains('active')) {
          closeItem(other);
        }
      });

      item.classList.contains('active')
        ? closeItem(item)
        : openItem(item);

    });

    function openItem(item) {
      const answer = item.querySelector('.faq-answer');
      item.classList.add('active');

      answer.style.height = answer.scrollHeight + 'px';

      answer.addEventListener('transitionend', function t() {
        answer.style.height = 'auto';
        answer.removeEventListener('transitionend', t);
      });
    }

    function closeItem(item) {
      const answer = item.querySelector('.faq-answer');

      // auto → px (important step)
      answer.style.height = answer.scrollHeight + 'px';

      requestAnimationFrame(() => {
        answer.style.height = '0px';
      });

      item.classList.remove('active');

      // pause videos
      item.querySelectorAll('video').forEach(v => v.pause());
    }

  });

});
